import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTradeInDetails } from "../trade-in-your-car-wrapper/actions";
import MyAccountTradeIn from "./component";

const mapStateToProps = ({
    user: {
        isLoggedIn,
        secureToken
    },
    tradeIn: {
        tradeInData,
        isGetTradeInDataError,
        isGetTradeInDataLoading
    }
}) => ({
    isLoggedIn,
    tradeInData,
    isGetTradeInDataError,
    isGetTradeInDataLoading,
    secureToken
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getTradeInDetailsConnect: getTradeInDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountTradeIn);
